import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  matchPath,
} from "react-router-dom";
import Header from "../Screen/Header/Header";
import Wallet from "../Screen/Wallet";
import AddProperty from "../Screen/AddProperty";
import PropertyList from "../components/Header/Property/PropertyList";
import { Box, CssBaseline } from "@mui/material";
import Sidebar from "../Screen/Sidebar";
import VendorSubscriptionScreen from "../Screen/VendorSubscriptionScreen";
import ChangePassword from "../Screen/ChangePassword";
import BankDetalis from "../Screen/BankDetalis";
import LegalTeam from "../Screen/LegalTeam";
import Help from "../Screen/Help";
import KYC from "../Screen/KYCScreen";
import SendMessage from "../components/Pages/Help/SendMessage";
import KYCCompleted from "../components/Pages/KYC/KYCCompleted";
import KYCNew from "../components/Pages/KYC/KYCNew";
import KYCPending from "../components/Pages/KYC/KYCPending";
import KYCRejected from "../components/Pages/KYC/KYCRejected";
import EditProfile from "../components/Profile/EditProfile";
import AddWallet from "../components/Header/Wallet/AddWallet";
import EditBankDetails from "../Screen/EditBankDetails";
import WalletPending from "../components/Header/Wallet/WalletPending";
import VendorSubscriptionDetalis from "../components/VendorSubscription/VendorSubscriptionDetails";
import VendorSubscriptionPayment from "../components/VendorSubscription/VendorSubscriptionPayment";
import PropertyDetailsScreen from "../Screen/PropertyDetailsScreen";
import PropertyDocument from "../components/PropertyDetalis/PropertyDocument";
import PropertyImages from "../components/PropertyDetalis/PropertyImages";
import ProjectDetailsScreen from "../Screen/ProjectDetailsScreen";
import SubscriptionPlans from "../components/VendorSubscription/SubscriptionPlans";
import { useSelector } from "react-redux";
import EditProperty from "../components/YourProperty/EditProperty";
import YourPropertyScreen from "../Screen/YourPropertyScreen";
import YourPropertyList from "../components/YourProperty/YourProertyList";
import AdvancePayment from "../components/ProjectDetails/AdvancePayment";
import LikedProperties from "../components/PropertyDetalis/LikedProperties";
import NotificationPanel from "../components/notification/Notification";
import NotificationDetail from "../components/notification/NotificationDetails";
import SiteVisit from "../components/CustomerInteractions/SiteVisit";
import YourProjectScreen from "../Screen/YourProjectScreen";
import AddDocuments from "../components/YourProperty/AddDocuments";
import AddPlot from "../components/YourProperty/AddPlot";
import UpdatePrice from "../components/YourProperty/UpdatePrice";
import SearchPropertyScreen from "../Screen/SearchPropertyScreen";
import HomeSearch from "../components/HomeSearch/HomeSearch";
import PropertiesListingPage from "../Screen/PropertiesListingPage";
import AboutUs from "../components/Footer/AboutUs";
import ContactUs from "../components/Footer/ContactUs";
import LandPolicy from "../components/Footer/LandPolicy";
import TermsAndConditions from "../components/Footer/TermsAndConditions";
import Footer from "../components/Footer/Footer";
import AddImages from "../components/YourProperty/AddImages";
import Withdraw from "../components/Header/Wallet/Withdraw";
import AddProjectDocuments from "../components/YourProperty/AddProjectDocuments";
import BookedPropertiesScreen from "../Screen/BookedPropertiesScreen";
import IndividualVillaScreen from "../Screen/IndividualVillaScreen";
import ApartmentPlotsScreen from "../Screen/ApartmentPlotsScreen";
import EditVillaDetails from "../components/YourProperty/IndividualVilla/EditVillaDetails";
import YourIndividualVillaOverview from "../components/YourProperty/IndividualVilla/YourIndividualVillaOverview";
import YourIndividualVillaScreen from "../Screen/YourIndividualVillaScreen";
import YourApartmentPlotsScreen from "../Screen/YourApartmentPlotsScreen";
import BookedProjectDetailsScreen from "../Screen/BookedProjectDetailsScreen";
import YourApartmentPlotAddImages from "../components/YourProperty/YourApartmentPlots/YourApartmentPlotAddImages";
import YourApartmentsPlotsAddDocuments from "../components/YourProperty/YourApartmentPlots/YourApartmentPlotAddDocuments";
import AddVillaImages from "../components/YourProperty/IndividualVilla/AddVillaImages";
import EditApartmentPlotsDetails from "../components/YourProperty/YourApartmentPlots/EditApartmentPlotsDetails";
import ApartmentPriceUpdate from "../components/YourProperty/YourApartmentPlots/ApartmentPriceUpdate";
import ForgetPassword from "../components/common/ForgetPassword";
import VerifyOtp from "../components/common/VerifyOTP";
import ResetPassword from "../components/common/ResetPassword";
import VerificationPage from "../components/common/VerificationPage";
import { useMediaQuery } from "@mui/material";
import RefundAndCancellationPolicy from "../components/Footer/RefundAndCancellationPolicy";
import Disclaimer from "../components/Footer/Disclaimer";
import AllProperties from "../components/Header/Property/AllProperties";
import PostRequirement from "../components/CustomerInteractions/BuyerRequirements";
import MobileBottomNav from "./BottomTabNav";
import ScrollToTop from "../components/common/ScrollTop";
import FloatingContactBar from "../components/common/FloatingContactBar";
import MobileSearchDrawer from "../components/common/MobileSearchDrawer";
import VendorSiteVisits from "../components/Pages/VendorSiteVisits";
import EnquiryList from "../components/vendorenquiries/EnquiryList";
import NotFound from "../components/common/NotFound";

/** All defined app routes — used to detect unknown paths for Header + 404 UI */
const KNOWN_ROUTE_PATTERNS = [
  "/",
  "/home",
  "/properties",
  "/search-properties",
  "/Wallet",
  "/post-your-property",
  "/PropertyList",
  "/owners/subscription/plans",
  "/ChangePassword",
  "/BankDetails",
  "/legal-team",
  "/Help",
  "/KYC",
  "/SendMessage",
  "/KYCCompleted",
  "/KYCRejected",
  "/KYCNew",
  "/KYCPending",
  "/myprofile",
  "/AddWallet",
  "/EditBankDetails",
  "/WalletPending",
  "/profile/sitevisits",
  "/profile/enquiries",
  "/VendorSubscriptionDetalis",
  "/schedulesitevisit",
  "/VendorSubscriptionPayment",
  "/PropertyDetailsScreen",
  "/AllProperties",
  "/ProjectDetailsScreen",
  "/SubscriptionPlans",
  "/YourPropertyScreen",
  "/profile/properties",
  "/favorites",
  "/notifications",
  "/editProperty",
  "/notificationdetails",
  "/AdvancePayment",
  "/editproperty",
  "/priceupdate",
  "/YourProjectScreen",
  "/addDocuments",
  "/about",
  "/contact",
  "/privacy",
  "/terms-and-condition",
  "/RefundAndCancellationPolicy",
  "/disclaimer",
  "/AddImages",
  "/withdraw",
  "/addProjectDocuments",
  "/addPlot",
  "/bookedProperties",
  "bookedProperties",
  "/IndividualVillaScreen",
  "/ApartmentPlotsScreen",
  "/EditVillaDetails",
  "/YourVillaScreen",
  "/YourApartmentScreen",
  "/BookedProjectDetailsScreen",
  "/YourApartmentPlotAddImages",
  "/YourApartmentsPlotsAddDocuments",
  "/AddVillaImages",
  "/EditApartmentPlotsDetails",
  "/UpdatePropertyPrice",
  "/forget-password",
  "/verify-otp",
  "/reset-password",
  "/verification/:token/:user",
  "/post-requirement",
  "/search",
  "/property/:slug",
  "/project/:slug",
  "/villa/:slug",
  "/apartment/:slug",
  "/myprofile/reset-password",
];

function NavigatorContent() {
  const isAuthenticated = useSelector((state) => state.user.isAuthenticated);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const [searchQuery, setSearchQuery] = useState("");
  const isMobile = useMediaQuery("(max-width:600px)");
  const [collapsed, setCollapsed] = useState(!isMobile);
  const hideMobileNav = location.pathname === "/post-your-property";


  useEffect(() => {
    setCollapsed(!isMobile);
  }, [isMobile]);

  const theme = useSelector((data) => data.themeValue.colors)
  const themeMode = useSelector((data) => data.themeValue.theme)
  const drawerWidth = collapsed ? 70 : 240;


  const isAuthPage =
    ["/ForgetPassword", "/VerifyOTP", "/reset-password"].includes(location.pathname) ||
    matchPath("/verification/:token/:user", location.pathname);

  const isPropertyPage = location.pathname.startsWith("/property/");
  const isProjectPage = location.pathname.startsWith("/project/");
  const isVillaPage = location.pathname.startsWith("/villa/");
  const isApartmentPage = location.pathname.startsWith("/apartment/");

  const isKnownRoute = KNOWN_ROUTE_PATTERNS.some((pattern) =>
    matchPath({ path: pattern, end: true }, location.pathname)
  );
  // /login, /register, and any other unmatched path → Not Found UI (with Header)
  const isNotFoundPage = !isKnownRoute;

  const showHeader =
    (!isAuthPage && isAuthenticated) ||
    location.pathname === "/" ||
    location.pathname === "/search-properties" ||
    location.pathname === "/properties" ||
    isPropertyPage ||
    isProjectPage ||
    isVillaPage ||
    isApartmentPage ||
    location.pathname === "/terms-and-condition" ||
    location.pathname === "/privacy" ||
    location.pathname === "/disclaimer" ||
    location.pathname === "/contact" ||
    location.pathname === "/about" ||
    location.pathname === "/forget-password" ||
    location.pathname === "/verify-otp" ||
    location.pathname === "/legal-team" ||
    isNotFoundPage;

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      {(!isAuthPage && isAuthenticated) && (
        <Sidebar
          drawerWidth={drawerWidth}
          mobileOpen={mobileOpen}
          collapsed={collapsed}
          setCollapsed={setCollapsed}
          onDrawerToggle={handleDrawerToggle}
        />
      )}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          marginLeft: (!isAuthPage && isAuthenticated) ? { sm: `${drawerWidth}px` } : 0,
          transition: "margin 0.3s ease",
          backgroundColor: theme.screen_background,
          minHeight: "calc(100vh - 80px)",
          //  mt: (!isAuthPage && !isBannerPage) ? "80px" : 0
          mt: (!isAuthPage) ? { xs: "76px", sm: "88px" } : 0
        }}
      >
        {/* Show Header for "/", even if not authenticated */}
        {/* {((!isAuthPage && isAuthenticated) || location.pathname === "/" || location.pathname === "/SearchPropertyScreen" || location.pathname === "/property/:slug" || location.pathname === "/ProjectDetailsScreen" ||
         location.pathname === "/IndividualVillaScreen" || location.pathname === "/ApartmentPlotsScreen" || location.pathname === "/terms-and-condition" || location.pathname === "/privacy" || location.pathname === "/disclaimer" || location.pathname === "/contact" || location.pathname === "/about") &&
          <Header
            onDrawerToggle={handleDrawerToggle}
            onSearchChange={setSearchQuery}
            currentPath={location.pathname}
          />
        
        } */}

        {showHeader && (
            <Header
              onDrawerToggle={handleDrawerToggle}
              onSearchChange={setSearchQuery}
              currentPath={location.pathname}
            />
          )}

        <Routes>
          <Route path="/" element={<HomeSearch />} />




          {/* <Route path="/" element={<Home  searchQuery={searchQuery} />} /> */}
          <Route path="/home" element={<HomeSearch />} />
          <Route path="/properties" element={<PropertiesListingPage />} />
          <Route path="/search-properties" element={<SearchPropertyScreen collapsed={collapsed} />} />
          <Route path="/Wallet" element={<Wallet />} />
          <Route path="/post-your-property" element={<AddProperty />} />
          <Route path="/PropertyList" element={<PropertyList searchQuery={searchQuery} />} />
          <Route
            path="/owners/subscription/plans"
            element={<VendorSubscriptionScreen />}
          />
          <Route path="/ChangePassword" element={<ChangePassword />} />
          <Route path="/BankDetails" element={<BankDetalis />} />
          <Route path="/legal-team" element={<LegalTeam />} />
          <Route path="/Help" element={<Help />} />
          <Route path="/KYC" element={<KYC />} />
          <Route path="/SendMessage" element={<SendMessage />} />
          <Route path="/KYCCompleted" element={<KYCCompleted />} />
          <Route path="/KYCRejected" element={<KYCRejected />} />
          <Route path="/KYCNew" element={<KYCNew />} />
          <Route path="/KYCPending" element={<KYCPending />} />
          <Route path="/myprofile" element={<EditProfile />} />
          <Route path="/AddWallet" element={<AddWallet />} />
          <Route path="/EditBankDetails" element={<EditBankDetails />} />
          <Route path="/WalletPending" element={<WalletPending />} />
            <Route path="/profile/sitevisits" element={<VendorSiteVisits />} />
            <Route path="/profile/enquiries" element={<EnquiryList />} />
          <Route
            path="/VendorSubscriptionDetalis"
            element={<VendorSubscriptionDetalis />}
          />
          <Route path="/schedulesitevisit" element={<SiteVisit />} />
          <Route
            path="/VendorSubscriptionPayment"
            element={<VendorSubscriptionPayment />}
          />
          <Route
            path="/PropertyDetailsScreen"
            element={<PropertyDetailsScreen />}
          />
          <Route
            path="/AllProperties"
            element={<AllProperties />}
          />
          <Route
            path="/ProjectDetailsScreen"
            element={<ProjectDetailsScreen />}
          />
          <Route
            path="/SubscriptionPlans"
            element={<SubscriptionPlans />}
          />
          <Route
            path="/YourPropertyScreen"
            element={<YourPropertyScreen />}
          />
          <Route path="/profile/properties" element={<YourPropertyList />} />
          <Route path="/favorites" element={<LikedProperties />} />
          {/* <Route path="/PropertyImages" element={<PropertyImages />} /> */}
          <Route path="/notifications" element={<NotificationPanel />} />
          <Route path="/editProperty" element={<EditProperty />} />
          <Route path="/notificationdetails" element={<NotificationDetail />} />
          <Route path="/AdvancePayment" element={<AdvancePayment />} />
          <Route path="/editproperty" element={<EditProperty />} />
          <Route path="/priceupdate" element={<UpdatePrice />} />
          <Route path="/YourProjectScreen" element={<YourProjectScreen />} />
          <Route path="/addDocuments" element={<AddDocuments />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/privacy" element={<LandPolicy />} />
          <Route path="/terms-and-condition" element={<TermsAndConditions />} />
          <Route path="/RefundAndCancellationPolicy" element={<RefundAndCancellationPolicy />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
          <Route path="/AddImages" element={<AddImages />} />
          <Route path="/withdraw" element={<Withdraw />} />
          <Route path="/addProjectDocuments" element={<AddProjectDocuments />} />
          <Route path="/addPlot" element={<AddPlot />} />
          <Route path="bookedProperties" element={<BookedPropertiesScreen />} />
          <Route path="/IndividualVillaScreen" element={<IndividualVillaScreen />} />
          <Route path="/ApartmentPlotsScreen" element={<ApartmentPlotsScreen />} />
          <Route path="/EditVillaDetails" element={<EditVillaDetails />} />
          <Route path="/YourVillaScreen" element={<YourIndividualVillaScreen />} />
          <Route path="/YourApartmentScreen" element={<YourApartmentPlotsScreen />} />
          <Route path="/BookedProjectDetailsScreen" element={<BookedProjectDetailsScreen />} />
          <Route path="/YourApartmentPlotAddImages" element={<YourApartmentPlotAddImages />} />
          <Route path="/YourApartmentsPlotsAddDocuments" element={<YourApartmentsPlotsAddDocuments />} />
          <Route path="/AddVillaImages" element={<AddVillaImages />} />
          <Route path="/EditApartmentPlotsDetails" element={<EditApartmentPlotsDetails />} />
          <Route path="/UpdatePropertyPrice" element={<ApartmentPriceUpdate />} />
          <Route path="/forget-password" element={<ForgetPassword />} />
          <Route path="/verify-otp" element={<VerifyOtp />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/verification/:token/:user" element={<VerificationPage />} />
          <Route path="/post-requirement" element={<PostRequirement />} />
          <Route
            path="/search"
            element={<MobileSearchDrawer />}
          />



          <Route path="/property/:slug" element={<PropertyDetailsScreen />} />
          <Route path="/project/:slug" element={<ProjectDetailsScreen />} />
          <Route path="/villa/:slug" element={<IndividualVillaScreen />} />
          <Route path="/apartment/:slug" element={<ApartmentPlotsScreen />} />
          <Route path="/myprofile/reset-password" element={<ResetPassword/>} />

          {/* Removed auth pages — show Not Found (same as unknown routes) */}
          <Route path="/login" element={<NotFound />} />
          <Route path="/register" element={<NotFound />} />
          <Route path="/Register" element={<NotFound />} />
          <Route path="*" element={<NotFound />} />

        </Routes>
        {(!isAuthPage && !hideMobileNav) &&
          <Footer />
        }
        {/* {!hideMobileNav && <MobileBottomNav />} */}
      </Box>
    </Box>
  );
}
function Navigator() {


  return (
    <Router>
      <ScrollToTop />
      <NavigatorContent />
      <FloatingContactBar />
      <MobileBottomNav />
    </Router>
  );
}
export default Navigator;